import React, { useCallback, useState } from 'react'
import StepperPill from '../../../components/TOO/StepperPill/StepperPill'
import StepOne from '../../../components/TOO/StepOne/StepOne'
import ConfirmStep from '../../../components/TOO/ConfirmStep/ConfirmStep'
import ReviewSendView from '../../../components/TOO/ReviewSendView/ReviewSendView'
import TrackHandover from '../../../components/TOO/TrackHandover/TrackHandover'
import StepTwo from '../../../components/TOO/StepTwo/StepTwo'
import { UserProperty } from '../../../generated/graphql'
import { NewCustomerType } from '../../../types'
import axios from 'axios'
import { getJWT } from '../../../helpers/auth'
import Lobby from '../../../components/TOO/Lobby/Lobby'
import { useAuthContext } from '../../../context/AuthProvider'
import CustomText from '../../../components/CustomText'
import PropertyCardDuex from '../../../components/TOO/PropertyCard/PropertyCardDuex'

type TOO_Item = {
  count: number
  title: string
  isActive: boolean
  passedStepper: boolean
}

const TOO_STEPS: TOO_Item[] = [
  {
    count: 1,
    title: 'Start transfer',
    isActive: false,
    passedStepper: false
  },
  {
    count: 2,
    title: 'New owner',
    isActive: false,
    passedStepper: false
  },
  {
    count: 3,
    title: 'Review & send',
    isActive: false,
    passedStepper: false
  },
  {
    count: 4,
    title: 'Confirmation',
    isActive: false,
    passedStepper: false
  },
  {
    count: 5,
    title: 'Track handover',
    isActive: false,
    passedStepper: false
  }
]

const TOOPage = (): JSX.Element => {
  const { user } = useAuthContext()
  const [activeStep, setActiveStep] = useState<TOO_Item>(TOO_STEPS[0])
  const [beginProcess, setBeginProcess] = useState<boolean>(false)
  const [activeProperty, setActiveProperty] = useState<UserProperty | undefined>()
  const [newCustomer, setNewCustomer] = useState<NewCustomerType>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleSetActiveProperty = (prop: UserProperty) => {
    setActiveProperty(prop)
  }

  const handleReviewSend = async () => {
    setIsLoading(true)
    //setActiveStep(TOO_STEPS[3])
    const mutableActivePropertyObject = activeProperty

    const bodyData = {
      user: {
        email: newCustomer?.email?.toLowerCase().trim(),
        firstName: newCustomer?.firstName,
        lastName: newCustomer?.lastName,
        contactNumber: newCustomer?.contactNumber,
        // promoCode: userData?.promoCode,
        // idPassportNumber: userData?.idPassportNumber,
        preferredContactMethod: '',
        password: '',
        alternativeContact: {
          email: '',
          firstName: '',
          lastName: '',
          phoneNumber: '',
          relationshipToCustomer: ''
        }
      },
      property: {
        entityType: mutableActivePropertyObject?.entityType,
        propertyLat: mutableActivePropertyObject?.propertyLat,
        propertyLng: mutableActivePropertyObject?.propertyLng,
        propertyW3w: mutableActivePropertyObject?.propertyW3w,
        fullAddress: mutableActivePropertyObject?.fullAddress?.trim(),
        streetAddress: `${mutableActivePropertyObject?.streetNumber?.trim()} ${mutableActivePropertyObject?.streetName?.trim()}`,
        streetNumber: mutableActivePropertyObject?.streetNumber?.trim(),
        streetName: `${mutableActivePropertyObject?.streetName?.trim()}`,
        suburb: mutableActivePropertyObject?.suburb?.trim(),
        city: mutableActivePropertyObject?.city?.trim(),
        postalCode: mutableActivePropertyObject?.postalCode?.trim(),
        province: mutableActivePropertyObject?.province?.trim(),
        country: mutableActivePropertyObject?.country?.trim() || 'South Africa',
        dwellingType: mutableActivePropertyObject?.dwellingType,
        complexBuildingName: mutableActivePropertyObject?.complexBuildingName || '',
        unitNumber: mutableActivePropertyObject?.unitNumber || '',
        roofLat: mutableActivePropertyObject?.propertyLat,
        roofLng: mutableActivePropertyObject?.propertyLng,
        roofW3w: mutableActivePropertyObject?.propertyW3w,
        roofLocationConfirmed: true,
        customerType: mutableActivePropertyObject?.customerType,
        monthlyElectricitySpend: mutableActivePropertyObject?.monthlyElectricitySpend,
        electricityPhaseType: mutableActivePropertyObject?.electricityPhaseType,
        electricityProvider: mutableActivePropertyObject?.electricityProvider,
        backupPowerNeeds: 'Yes',
        roofType: mutableActivePropertyObject?.roofType,
        subscription: {
          addOnBatteryComponentID:
            mutableActivePropertyObject?.subscription?.systemConfig?.addOnBatteryComponentID,
          addOnPanelComponentID:
            mutableActivePropertyObject?.subscription?.systemConfig?.addOnPanelComponentID,
          baseProductID: mutableActivePropertyObject?.subscription?.systemConfig?.baseProductID,
          baseProductName: mutableActivePropertyObject?.subscription?.systemConfig?.baseProductName,
          division: mutableActivePropertyObject?.subscription?.systemConfig?.division,
          numberOfAddOnBatteries:
            mutableActivePropertyObject?.subscription?.systemConfig?.numberOfAddOnBatteries,
          numberOfAddOnPanels:
            mutableActivePropertyObject?.subscription?.systemConfig?.numberOfAddOnPanels
        },
        isRoofFlat: mutableActivePropertyObject?.isRoofFlat,
        insurance: mutableActivePropertyObject?.insurance ? 'Yes' : 'No',
        originalCoCAvailable: mutableActivePropertyObject?.originalCoCAvailable,
        meterType: mutableActivePropertyObject?.meterType,
        leadChannel: 'TOO',
        municipality: mutableActivePropertyObject?.electricityProvider,
        passportUsed: false,
        monthlyElectricityUsage: '',
        promoCode: '',
        registeredBusinessNumber: mutableActivePropertyObject?.registeredBusinessNumber,
        activeCampaignCode: '',
        fieldSalesAgent: '',
        teleSalesAgent: '',
        idPassportNumber: newCustomer?.idNumber || '',
        installerCode: '',
        prevCustomerOrderNumber: activeProperty?.orderNumber || undefined,
        prevCustomerHubRecordId: activeProperty?.recordId || undefined,
        tooReason: newCustomer?.reason?.trim() || '',
        tooReasonDescription: newCustomer?.reasonDescription?.trim() || ''
      },
      recordId: activeProperty?.recordId
    }

    const API_BASE_URL = process.env.REACT_APP_API_HOST

    console.log(`bodyData: `, bodyData)

    const resp = await axios.post(
      `${API_BASE_URL}/too-review-and-send`,
      {
        ...bodyData
      },
      {
        headers: {
          Authorization: getJWT()
        }
      }
    )

    if (resp.status !== 200) {
      throw new Error('Error generating agreement')
    }

    console.log(`resp.data: `, resp.data)

    const { status, message } = resp.data

    if (status === 'success') {
      setActiveStep(TOO_STEPS[3])
    }

    setIsLoading(false)
    return { status, message }
  }

  const renderCorrectStep = useCallback(
    (step: number) => {
      switch (step) {
        case 1:
          return (
            <StepOne
              stepCount={1}
              totalStep={5}
              title={"Let's start your transfer"}
              description={
                'Have a quick look — these are the details on file for your home and system. If anything looks off, contact support before continuing.'
              }
              handleBack={() => setBeginProcess(false)}
              handleNext={() => setActiveStep(TOO_STEPS[1])}
              handleSetActiveProperty={handleSetActiveProperty}
              activeProperty={activeProperty}
            />
          )
        case 2:
          return (
            <StepTwo
              stepCount={2}
              totalStep={5}
              handleBack={() => setActiveStep(TOO_STEPS[0])}
              handleNext={(e) => {
                setActiveStep(TOO_STEPS[2])
                setNewCustomer(e)
              }}
              title={'Introduce the new homeowner'}
              description={`We'll reach out to them directly with a short onboarding to complete.`}
              newCustomer={newCustomer}
              activeProperty={activeProperty}
            />
          )

        case 3:
          return (
            <ReviewSendView
              isLoading={isLoading}
              stepCount={3}
              totalStep={5}
              // handleBack={() => setActiveStep(TOO_STEPS[1])}
              handleBack={() => {
                if (newCustomer?.transferOfOwnershipStep) {
                  setNewCustomer(undefined)
                  setBeginProcess(false)
                  setActiveProperty(undefined)
                  setActiveStep(TOO_STEPS[0])
                } else {
                  setActiveStep(TOO_STEPS[1])
                }
              }}
              handleNext={handleReviewSend}
              title={'Review and send'}
              description={'A last look before we email the onboarding link to the new owner.'}
              activeProperty={activeProperty}
              newCustomer={newCustomer}
            />
          )

        case 4:
          return (
            <ConfirmStep
              stepCount={4}
              totalStep={5}
              handleBack={() => {
                if (newCustomer?.transferOfOwnershipStep) {
                  setNewCustomer(undefined)
                  setBeginProcess(false)
                  setActiveProperty(undefined)
                  setActiveStep(TOO_STEPS[0])
                } else {
                  setActiveStep(TOO_STEPS[2])
                }
              }}
              title={'Invite sent to Sam.'}
              description={`We've emailed a unique onboarding link to derik@gosolr.co.za · Jul 2, 4:23 AM.`}
              handleNext={() => setActiveStep(TOO_STEPS[4])}
              newCustomer={newCustomer}
            />
          )
        case 5:
          return (
            <TrackHandover
              stepCount={5}
              totalStep={5}
              handleBack={() => {
                if (newCustomer?.transferOfOwnershipStep) {
                  setNewCustomer(undefined)
                  setBeginProcess(false)
                  setActiveProperty(undefined)
                  setActiveStep(TOO_STEPS[0])
                } else {
                  setActiveStep(TOO_STEPS[3])
                }
              }}
              title={'The handover is in motion'}
              description={`Here's where things stand. We'll text and email you as each milestone lands.`}
              newCustomer={newCustomer}
            />
          )
        default:
          break
      }
    },
    [activeProperty, newCustomer, isLoading]
  )

  console.log(`user?.info?.properties: `, user?.info?.properties)

  return beginProcess ? (
    <div className="w-full h-full flex flex-col gap-y-[28px]">
      <div className="w-full h-auto flex flex-row justify-between items-center gap-x-[8px]">
        <StepperPill
          count={TOO_STEPS[0].count.toString()}
          label={TOO_STEPS[0].title}
          isActive={activeStep?.count === TOO_STEPS[0].count}
          handleClick={() => null}
          disableButton={false}
          passedStepper={TOO_STEPS[0].count < activeStep.count}
        />
        <div
          className={`w-[100px] h-[1.2px]  ${TOO_STEPS[0].count <= activeStep.count ? 'bg-[#ffbe00]' : 'bg-[#cdcdcd]'} mb-[32px]`}
        ></div>
        <StepperPill
          count={TOO_STEPS[1].count.toString()}
          label={TOO_STEPS[1].title}
          isActive={activeStep?.count === TOO_STEPS[1].count}
          handleClick={() => null}
          disableButton={false}
          passedStepper={TOO_STEPS[1].count < activeStep.count}
        />
        <div
          className={`w-[100px] h-[1.2px]  ${TOO_STEPS[1].count <= activeStep.count ? 'bg-[#ffbe00]' : 'bg-[#cdcdcd]'} mb-[32px]`}
        ></div>
        <StepperPill
          count={TOO_STEPS[2].count.toString()}
          label={TOO_STEPS[2].title}
          isActive={activeStep?.count === TOO_STEPS[2].count}
          handleClick={() => null}
          disableButton={false}
          passedStepper={TOO_STEPS[2].count < activeStep.count}
        />
        <div
          className={`w-[100px] h-[1.2px]  ${TOO_STEPS[2].count <= activeStep.count ? 'bg-[#ffbe00]' : 'bg-[#cdcdcd]'} mb-[32px]`}
        ></div>
        <StepperPill
          count={TOO_STEPS[3].count.toString()}
          label={TOO_STEPS[3].title}
          isActive={activeStep?.count === TOO_STEPS[3].count}
          handleClick={() => null}
          disableButton={false}
          passedStepper={TOO_STEPS[3].count < activeStep.count}
        />
        <div
          className={`w-[100px] h-[1.2px]  ${TOO_STEPS[3].count <= activeStep.count ? 'bg-[#ffbe00]' : 'bg-[#cdcdcd]'} mb-[32px]`}
        ></div>
        <StepperPill
          count={TOO_STEPS[4].count.toString()}
          label={TOO_STEPS[4].title}
          isActive={activeStep?.count === TOO_STEPS[4].count}
          handleClick={() => null}
          disableButton={false}
          passedStepper={TOO_STEPS[4].count < activeStep.count}
        />
      </div>

      {renderCorrectStep(activeStep?.count)}
    </div>
  ) : (
    <div className={`w-full h-auto flex flex-col gap-y-4`}>
      <div className={`w-full h-auto flex flex-col gap-y-4`}>
        <CustomText
          textLabel={'Properties under your name'}
          fontWeight={`font-bold`}
          fontSize="text-[28px]"
          fontColor={`text-black`}
        />
      </div>
      <div className="w-full p-12 bg-white rounded-[32px] shadow-sm border-[1.5px] border-[#e4e4e4] grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {user?.info?.properties &&
          user?.info?.properties?.map(
            (item, idx) =>
              item && (
                <PropertyCardDuex
                  key={`${idx + 1}`}
                  active={!item?.tooData?.email ? false : true}
                  property={item}
                  handleClick={() => {
                    if (!item?.tooData?.email) {
                      setActiveProperty(item)
                      setNewCustomer(undefined)
                    } else {
                      setNewCustomer({
                        firstName: item?.tooData?.firstName || '' || '',
                        lastName: item?.tooData?.lastName || '',
                        email: item?.tooData?.email || '',
                        contactNumber: item?.tooData?.contactNumber || '',
                        idNumber: item?.tooData?.idPassportNumber || '',
                        transferDate: item?.tooData?.expectedMoveDate || '',
                        transferOfOwnershipCompleted:
                          (item?.tooData?.transferOfOwnershipCompleted as unknown as boolean) ||
                          false,
                        transferOfOwnershipStep: item?.tooData?.transferOfOwnershipStep || '',
                        userRecordId: item?.tooData?.userRecordId || ''
                      })
                      item && setActiveProperty(item)

                      if (item?.tooData?.transferOfOwnershipStep === 'sent') {
                        setActiveStep(TOO_STEPS[4])
                      } else {
                        setActiveStep(TOO_STEPS[2])
                      }
                    }

                    setBeginProcess(true)
                  }}
                />
              )
          )}
      </div>
    </div>
  )
}

export default TOOPage
